export function ThatsAllSection() {
  return (
    <div className="max-w-374p flex justify-between items-center mx-auto py-20p">
      <img src="assets/pecat_1.svg" alt="cep logo" />
      <p className="pl-20p text-14p font-bold">To je sve za sada, ali provjeri kasnije za više!</p>
    </div>
  );
}
